import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface KronosSubmission {
  id: string;
  folio: string;
  nombre: string;
  email: string;
  telefono: string;
  servicio: string;
  mensaje: string;
  created_at: string;
}
